import React, { useRef, useEffect, useState } from 'react';
import MyMapsSymbolizer from './MyMapsSymbolizer.jsx';
import MyMapsBuffer from './MyMapsBuffer';
import MyMapsMeasure from './MyMapsMeasure';
import MyMapsPopupLabel from './MyMapsPopupLabel';
import './MyMapsPopup.css';
import * as helpers from '../../../helpers/helpers';

const MyMapsPopup = (props) => {
  const popupLabelRef = useRef(null);
  useEffect(() => {
    return () => {};
  }, []);

  return (
    <div className="fs-mymaps-popup-container">
      <MyMapsPopupLabel
        onRef={(ref) => (popupLabelRef.current = ref)}
        item={props.item}
        onLabelChange={props.onLabelChange}
        onLabelVisibilityChange={props.onLabelVisibilityChange}
        onLabelRotationChange={props.onLabelRotationChange}
      />
      <MyMapsSymbolizer
        visible={props.activeTool === 'symbolizer'}
        item={props.item}
        onPointStyleDropDown={props.onPointStyleDropDown}
        onRadiusSliderChange={props.onRadiusSliderChange}
        onFillColorPickerChange={props.onFillColorPickerChange}
        onFillOpacitySliderChange={props.onFillOpacitySliderChange}
        onRotationSliderChange={props.onRotationSliderChange}
        onStrokeOpacitySliderChange={props.onStrokeOpacitySliderChange}
        onStrokeColorPickerChange={props.onStrokeColorPickerChange}
        onStrokeWidthSliderChange={props.onStrokeWidthSliderChange}
        onStrokeTypeDropDown={props.onStrokeTypeDropDown}
      />
      <MyMapsBuffer visible={props.activeTool === 'buffer'} item={props.item} />
      <MyMapsMeasure
        visible={props.activeTool === 'measure'}
        item={props.item}
      />
      <FooterButtons
        onMyMapItemToolsButtonClick={(evt) =>
          props.onMyMapItemToolsButtonClick(evt, props.item)
        }
        onDeleteButtonClick={() => {
          props.onDeleteButtonClick(props.item.id);
          window.popup.hide();
        }}
      />
    </div>
  );
};

export default MyMapsPopup;

function FooterButtons(props) {
  return (
    <div className="fs-mymaps-footer-buttons-container">
      <button
        className="fs-button fs-mymaps-popup-footer-button"
        key={helpers.getUID()}
        id={helpers.getUID()}
        onClick={(evt) => props.onMyMapItemToolsButtonClick(evt)}
      >
        <img
          src={images['toolbox.png']}
          className={'fs-mymaps-footer-buttons-img'}
          alt="Tools"
        />
        Alati
      </button>
      <button
        className="fs-button fs-mymaps-popup-footer-button"
        key={helpers.getUID()}
        id={helpers.getUID()}
        onClick={props.onDeleteButtonClick}
      >
        <img
          src={images['eraser.png']}
          className={'fs-mymaps-footer-buttons-img'}
          alt="Delete"
        />
        Izbriši
      </button>
      <button
        className="fs-button fs-mymaps-popup-footer-button"
        key={helpers.getUID()}
        id={helpers.getUID()}
        onClick={() => {
          window.popup.hide();
        }}
      >
        <img
          src={images['closeX.gif']}
          className={'fs-mymaps-footer-buttons-img'}
          alt="Close"
        />
        Zatvori
      </button>
    </div>
  );
}

// IMPORT ALL IMAGES
const images = importAllImages(
  require.context('./images', false, /\.(png|jpe?g|svg|gif)$/)
);
function importAllImages(r) {
  let images = {};
  r.keys().map((item, index) => (images[item.replace('./', '')] = r(item)));
  return images;
}
